<template>
    <div class="user-profile">
        <aside class="profile-sidebar">
            <div class="sidebar-title">个人中心</div>
            <ul class="sidebar-menu">
                <li :class="{ active: activeMenu === 'profile' }" @click="activeMenu = 'profile'">
                    <i class="el-icon-user"></i>
                    <span>个人信息</span>
                </li>
                <li :class="{ active: activeMenu === 'coinLog' }" @click="activeMenu = 'coinLog'">
                    <i class="el-icon-document"></i>
                    <span>金币流水</span>
                </li>
            </ul>
        </aside>
        <div class="profile-main">
            <!-- 个人信息 -->
            <section v-show="showProfile" class="profile-card">
                <h2 class="profile-title"><i class="el-icon-user"></i> 个人信息</h2>
                <div v-loading="profileLoading" class="profile-sections">
                    <div class="section-title">注册信息</div>
                    <div class="info-grid">
                        <div class="info-row">
                            <span class="info-label">用户名</span>
                            <span class="info-value">{{ displayUsername }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">当前金币</span>
                            <span class="info-value coins">{{ displayCoins }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">绑定手机号</span>
                            <span class="info-value">{{ profile.phone || '未绑定' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">注册时间</span>
                            <span class="info-value">{{ profile.createdAt || '—' }}</span>
                        </div>
                        <div class="info-row invite-code-row">
                            <span class="info-label">我的邀请码</span>
                            <span class="info-value invite-code-value">
                                <span class="invite-code-text">{{ profile.inviteCode || '—' }}</span>
                                <el-button v-if="profile.inviteCode" type="text" size="small" icon="el-icon-document-copy" @click="copyInviteCode" class="copy-invite-btn">复制</el-button>
                            </span>
                        </div>
                        <div v-if="profile.inviteCode" class="invite-link-section">
                            <div class="invite-link-row">
                                <span class="info-label">邀请链接</span>
                                <span class="invite-link-value">
                                    <el-input :value="inviteLink" readonly size="small" class="invite-link-input">
                                        <el-button slot="append" type="primary" icon="el-icon-link" @click="copyInviteLink">复制链接</el-button>
                                    </el-input>
                                </span>
                            </div>
                            <div class="invite-qr-section">
                                <span class="info-label">邀请二维码</span>
                                <div class="invite-qr-wrap" @click="copyQrImage" title="点击复制二维码图片">
                                    <img v-if="qrDataUrl" :src="qrDataUrl" alt="邀请二维码" class="invite-qr-img">
                                    <span v-else class="invite-qr-placeholder">生成中…</span>
                                </div>
                                <p class="invite-qr-tip">点击二维码可复制图片</p>
                            </div>
                        </div>
                        <p class="invite-code-tip">分享邀请码或链接给好友，好友注册时填写您的邀请码即可多获 10 金币</p>
                    </div>
                    <!-- 分享统计 -->
                    <div v-if="profile.inviteCode" class="share-stats-section">
                        <div class="section-title">分享统计</div>
                        <div class="share-stats-grid">
                            <div class="share-stat-item">
                                <span class="share-stat-num">{{ shareStats.totalClicks }}</span>
                                <span class="share-stat-label">链接点击次数</span>
                            </div>
                            <div class="share-stat-item">
                                <span class="share-stat-num">{{ shareStats.totalRegistered }}</span>
                                <span class="share-stat-label">成功邀请注册</span>
                            </div>
                            <div class="share-stat-item">
                                <span class="share-stat-num">{{ shareStats.earnedCoins }}</span>
                                <span class="share-stat-label">获得奖励金币</span>
                            </div>
                        </div>
                    </div>
                    <!-- 未绑定手机时显示绑定领 5 金币 -->
                    <div v-if="!hasBoundPhone" class="bind-phone-section">
                        <div class="section-title">绑定手机领 5 金币</div>
                        <div class="bind-phone-tip"><i class="el-icon-present"></i> 绑定手机号即可获得 5 个金币奖励</div>
                        <el-form label-width="100px" size="medium" class="bind-phone-form">
                            <el-form-item label="手机号">
                                <el-input v-model="bindPhoneForm.phone" placeholder="请输入11位手机号" maxlength="11" show-word-limit clearable autocomplete="tel" name="dbtool-bind-phone"></el-input>
                            </el-form-item>
                            <el-form-item label="图形验证码">
                                <div class="captcha-row">
                                    <div class="captcha-code-box" @click="refreshBindCaptcha">{{ bindCaptchaCode || '点击获取' }}</div>
                                    <el-input v-model="bindPhoneForm.captchaValue" placeholder="输入左侧图形码" maxlength="6" clearable class="captcha-input" autocomplete="off" name="dbtool-bind-graphic"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item label="短信验证码">
                                <el-input v-model="bindPhoneForm.code" placeholder="输入短信码" maxlength="6" clearable autocomplete="off" name="dbtool-bind-sms">
                                    <el-button slot="append" type="primary" class="sms-code-btn" :disabled="bindSmsCountdown > 0" @click="sendBindSmsCode">
                                        {{ bindSmsCountdown > 0 ? bindSmsCountdown + '秒后重发' : '获取验证码' }}
                                    </el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" icon="el-icon-mobile-phone" @click="submitBindPhone" :loading="bindLoading">绑定并领取 5 金币</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="password-section">
                        <el-button v-if="!showPasswordForm" type="text" icon="el-icon-lock" @click="showPasswordForm = true">修改密码</el-button>
                        <div v-show="showPasswordForm" class="password-form">
                            <h4 class="form-subtitle">修改密码</h4>
                            <el-form label-width="100px" size="medium">
                                <el-form-item label="原密码">
                                    <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入原密码" show-password clearable></el-input>
                                </el-form-item>
                                <el-form-item label="新密码">
                                    <el-input v-model="passwordForm.newPassword" type="password" placeholder="至少6位" show-password clearable></el-input>
                                </el-form-item>
                                <el-form-item label="确认新密码">
                                    <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="再次输入新密码" show-password clearable></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" icon="el-icon-lock" @click="submitPassword" :loading="passwordLoading">保存新密码</el-button>
                                    <el-button @click="showPasswordForm = false">取消</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 金币流水 -->
            <section v-show="showCoinLog" class="profile-card coin-log-card">
                <h2 class="profile-title"><i class="el-icon-document"></i> 金币流水</h2>
                <div class="coin-log-toolbar">
                    <span class="toolbar-label">筛选：</span>
                    <el-radio-group v-model="flowFilter" size="small">
                        <el-radio-button label="all">全部</el-radio-button>
                        <el-radio-button label="spend">消费</el-radio-button>
                        <el-radio-button label="earn">赚取</el-radio-button>
                    </el-radio-group>
                </div>
                <div class="coin-log-list" v-loading="coinLogLoading">
                    <div v-if="filteredFlowList.length === 0 && !coinLogLoading" class="coin-log-empty">暂无记录</div>
                    <div v-else class="coin-log-items">
                        <div v-for="item in filteredFlowList" :key="item.id" :class="['coin-log-item', item.type]">
                            <span class="coin-log-amount">{{ item.type === 'spend' ? '-' : '+' }}{{ item.amount }}</span>
                            <span class="coin-log-remark">{{ item.remark || (item.type === 'spend' ? '消费' : '赚取') }}</span>
                            <span class="coin-log-time">{{ item.createdAt }}</span>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcode'
export default {
    name: 'UserProfile',
    data() {
        return {
            activeMenu: 'profile',
            showPasswordForm: false,
            profile: {},
            profileLoading: false,
            passwordForm: { oldPassword: '', newPassword: '', confirmPassword: '' },
            passwordLoading: false,
            flowFilter: 'all',
            coinLogLoading: false,
            coinLogList: [],
            bindPhoneForm: { phone: '', captchaValue: '', code: '' },
            bindCaptchaId: '',
            bindCaptchaCode: '',
            bindSmsCountdown: 0,
            bindLoading: false,
            qrDataUrl: '',
            shareStats: { totalClicks: 0, totalRegistered: 0, earnedCoins: 0 }
        }
    },
    computed: {
        inviteLink() {
            const code = this.profile.inviteCode
            if (!code) return ''
            if (typeof window === 'undefined') return ''
            return window.location.origin + (window.location.pathname || '/') + '#/?invite=' + encodeURIComponent(code)
        },
        hasBoundPhone() {
            const p = this.profile.phone
            return !!(p && String(p).trim())
        },
        displayUsername() {
            const u = this.$store.state.user
            return (u && u.username) ? u.username : (this.profile.username || '—')
        },
        displayCoins() {
            const u = this.$store.state.user
            if (u && u.coins != null) return u.coins
            return this.profile.coins != null ? this.profile.coins : 0
        },
        showProfile() {
            return this.activeMenu === 'profile'
        },
        showCoinLog() {
            return this.activeMenu === 'coinLog'
        },
        filteredFlowList() {
            const list = this.coinLogList || []
            if (this.flowFilter === 'spend') return list.filter(i => i.type === 'spend')
            if (this.flowFilter === 'earn') return list.filter(i => i.type === 'earn')
            return list
        }
    },
    mounted() {
        if (!this.$store.state.user) {
            this.$router.replace('/')
            this.$store.commit('SetShowLoginDialog', { show: true, tab: 'login' })
            return
        }
        this.fetchProfile()
        this.fetchCoinLog()
        this.loadShareStats()
    },
    methods: {
        fetchProfile() {
            const token = this.$store.state.user && this.$store.state.user.token
            if (!token) return
            this.profileLoading = true
            this.$axios.get('/user/profile', { params: { token } }).then(res => {
                this.profile = res.data || {}
                if (this.$store.state.user && res.data && res.data.coins != null) {
                    this.$store.commit('SetUserCoins', res.data.coins)
                }
                if (this.$store.state.user && res.data && res.data.hideFollowOfficialEarn != null) {
                    this.$store.commit('SetUserHideFollowOfficialEarn', !!res.data.hideFollowOfficialEarn)
                }
                const hasPhone = res.data && res.data.phone && String(res.data.phone).trim()
                if (!hasPhone) this.refreshBindCaptcha()
                if (res.data && res.data.inviteCode) this.generateQrCode()
            }).catch(() => {
                this.profile = {}
            }).finally(() => {
                this.profileLoading = false
            })
        },
        refreshBindCaptcha() {
            this.$axios.get('/captcha', { params: { t: Date.now() } }).then(res => {
                if (res.data && res.data.id && res.data.code) {
                    this.bindCaptchaId = res.data.id
                    this.bindCaptchaCode = res.data.code
                    this.bindPhoneForm.captchaValue = ''
                }
            }).catch(() => {})
        },
        sendBindSmsCode() {
            const phone = (this.bindPhoneForm.phone || '').trim()
            if (!/^1\d{10}$/.test(phone)) {
                this.$message({ message: '请输入正确的11位手机号', type: 'warning' })
                return
            }
            if (!this.bindCaptchaId || !(this.bindPhoneForm.captchaValue || '').trim()) {
                this.$message({ message: '请先输入图形验证码', type: 'warning' })
                return
            }
            const token = this.$store.state.user && this.$store.state.user.token
            if (!token) {
                this.$message({ message: '请先登录', type: 'warning' })
                return
            }
            this.$axios.post('/user/sms/send', {
                phone,
                type: 'bind',
                captchaId: this.bindCaptchaId,
                captchaValue: this.bindPhoneForm.captchaValue.trim(),
                token
            }).then(() => {
                this.$message({ message: '验证码已发送', type: 'success' })
                this.bindSmsCountdown = 60
                const t = setInterval(() => {
                    this.bindSmsCountdown--
                    if (this.bindSmsCountdown <= 0) clearInterval(t)
                }, 1000)
                this.refreshBindCaptcha()
            }).catch(err => {
                const msg = (err.response && err.response.data && err.response.data.message) ? err.response.data.message : '发送失败'
                this.$message({ message: msg, type: 'warning' })
                this.refreshBindCaptcha()
            })
        },
        submitBindPhone() {
            const phone = (this.bindPhoneForm.phone || '').trim()
            const code = (this.bindPhoneForm.code || '').trim()
            if (!/^1\d{10}$/.test(phone)) {
                this.$message({ message: '请输入正确的11位手机号', type: 'warning' })
                return
            }
            if (!code) {
                this.$message({ message: '请输入短信验证码', type: 'warning' })
                return
            }
            const token = this.$store.state.user && this.$store.state.user.token
            if (!token) {
                this.$message({ message: '请先登录', type: 'warning' })
                return
            }
            this.bindLoading = true
            this.$axios.post('/user/phone/bind', { token, phone, code }).then(res => {
                this.$message({ message: '绑定成功，已获得 5 金币', type: 'success' })
                if (res.data && res.data.coins != null) this.$store.commit('SetUserCoins', res.data.coins)
                this.profile.phone = phone
                this.bindPhoneForm = { phone: '', captchaValue: '', code: '' }
                this.refreshBindCaptcha()
            }).catch(err => {
                const msg = (err.response && err.response.data && err.response.data.message) ? err.response.data.message : '绑定失败'
                this.$message({ message: msg, type: 'warning' })
            }).finally(() => {
                this.bindLoading = false
            })
        },
        copyInviteCode() {
            const code = this.profile.inviteCode
            if (!code) return
            this.$copyText(code).then(() => {
                this.$message({ message: '邀请码已复制到剪贴板', type: 'success' })
            }).catch(() => {
                this.$message({ message: '复制失败', type: 'warning' })
            })
        },
        copyInviteLink() {
            if (!this.inviteLink) return
            this.$copyText(this.inviteLink).then(() => {
                this.$message({ message: '邀请链接已复制到剪贴板', type: 'success' })
            }).catch(() => {
                this.$message({ message: '复制失败', type: 'warning' })
            })
        },
        generateQrCode() {
            const link = this.inviteLink
            if (!link) return
            this.qrDataUrl = ''
            QRCode.toDataURL(link, { width: 200, margin: 2 }, (err, url) => {
                if (!err) this.qrDataUrl = url
            })
        },
        copyQrImage() {
            if (!this.qrDataUrl) return
            const dataUrl = this.qrDataUrl
            const img = new Image()
            img.crossOrigin = 'anonymous'
            img.onload = () => {
                try {
                    const canvas = document.createElement('canvas')
                    canvas.width = img.width
                    canvas.height = img.height
                    const ctx = canvas.getContext('2d')
                    ctx.drawImage(img, 0, 0)
                    canvas.toBlob(blob => {
                        if (!blob) {
                            this.$message({ message: '复制失败', type: 'warning' })
                            return
                        }
                        if (navigator.clipboard && navigator.clipboard.write) {
                            navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })])
                                .then(() => this.$message({ message: '二维码图片已复制到剪贴板', type: 'success' }))
                                .catch(() => this.$message({ message: '复制失败，请使用右键保存图片', type: 'warning' }))
                        } else {
                            this.$message({ message: '当前浏览器不支持复制图片，请使用右键保存', type: 'warning' })
                        }
                    }, 'image/png')
                } catch (e) {
                    this.$message({ message: '复制失败', type: 'warning' })
                }
            }
            img.onerror = () => this.$message({ message: '复制失败', type: 'warning' })
            img.src = dataUrl
        },
        fetchCoinLog() {
            const token = this.$store.state.user && this.$store.state.user.token
            if (!token) return
            this.coinLogLoading = true
            this.$axios.get('/user/coin-log', { params: { token } }).then(res => {
                this.coinLogList = Array.isArray(res.data) ? res.data : []
            }).catch(() => {
                this.coinLogList = []
            }).finally(() => {
                this.coinLogLoading = false
            })
        },
        loadShareStats() {
            const token = this.$store.state.user && this.$store.state.user.token
            if (!token) return
            this.$axios.get('/user/share-stats', { params: { token } }).then(res => {
                if (res.data) this.shareStats = res.data
            }).catch(() => {})
        },
        submitPassword() {
            const { oldPassword, newPassword, confirmPassword } = this.passwordForm
            if (!oldPassword) {
                this.$message({ message: '请输入原密码', type: 'warning' })
                return
            }
            if (!newPassword || newPassword.length < 6) {
                this.$message({ message: '新密码至少6位', type: 'warning' })
                return
            }
            if (newPassword !== confirmPassword) {
                this.$message({ message: '两次输入的新密码不一致', type: 'warning' })
                return
            }
            this.passwordLoading = true
            const token = this.$store.state.user && this.$store.state.user.token
            this.$axios.post('/user/password', { token, oldPassword, newPassword }).then(() => {
                this.$message({ message: '密码修改成功', type: 'success' })
                this.passwordForm = { oldPassword: '', newPassword: '', confirmPassword: '' }
                this.showPasswordForm = false
            }).catch(err => {
                const msg = (err.response && err.response.data && err.response.data.message) ? err.response.data.message : '修改失败'
                this.$message({ message: msg, type: 'warning' })
            }).finally(() => {
                this.passwordLoading = false
            })
        }
    }
}
</script>

<style lang="less" scoped>
.user-profile {
    display: flex;
    min-height: 500px;
    padding: 24px 0;
    max-width: 960px;
    margin: 0 auto;
    gap: 24px;
}
.profile-sidebar {
    width: 180px;
    flex-shrink: 0;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,.06);
    overflow: hidden;
}
.sidebar-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    padding: 16px 20px;
    border-bottom: 1px solid #ebeef5;
}
.sidebar-menu {
    list-style: none;
    margin: 0;
    padding: 12px 0;
}
.sidebar-menu li {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 20px;
    font-size: 14px;
    color: #606266;
    cursor: pointer;
    transition: background .2s, color .2s;
}
.sidebar-menu li i { font-size: 18px; color: #909399; }
.sidebar-menu li:hover { background: #f5f7fa; color: #409eff; }
.sidebar-menu li:hover i { color: #409eff; }
.sidebar-menu li.active {
    background: #ecf5ff;
    color: #409eff;
    font-weight: 500;
}
.sidebar-menu li.active i { color: #409eff; }
.profile-main {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
}
.profile-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,.06);
    overflow: hidden;
}
.profile-title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    padding: 16px 24px;
    margin: 0;
    border-bottom: 1px solid #ebeef5;
    display: flex;
    align-items: center;
    gap: 8px;
}
.profile-title i { color: #409eff; }
.profile-sections { padding: 24px; }
.section-title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    margin: 0 0 16px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #ebeef5;
}
.info-grid { margin-bottom: 24px; }
.info-row {
    display: flex;
    align-items: center;
    padding: 10px 0;
    font-size: 14px;
}
.info-label {
    width: 100px;
    color: #909399;
    flex-shrink: 0;
}
.info-value { color: #303133; }
.info-value.coins { color: #e6a23c; font-weight: 600; }
.invite-code-row { margin-top: 4px; }
.invite-code-value { display: inline-flex; align-items: center; gap: 8px; }
.invite-code-text { font-family: monospace; font-weight: 600; letter-spacing: 1px; }
.copy-invite-btn { padding: 0 4px; }
.invite-code-tip { font-size: 12px; color: #909399; margin: 4px 0 0 100px; line-height: 1.4; }
.invite-link-section { margin-top: 16px; }
.invite-link-row { display: flex; align-items: center; margin-bottom: 12px; }
.invite-link-row .info-label { width: 100px; flex-shrink: 0; }
.invite-link-value { flex: 1; min-width: 0; }
.invite-link-input { width: 100%; }
.invite-link-input ::v-deep .el-input__inner { font-size: 12px; }
.invite-link-input ::v-deep .el-input-group__append { padding: 0; }
.invite-link-input ::v-deep .el-input-group__append .el-button { margin: 0; }
.invite-qr-section { margin-top: 16px; }
.invite-qr-section .info-label { display: block; margin-bottom: 8px; }
.invite-qr-wrap {
    display: inline-block;
    padding: 12px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 10px;
    cursor: pointer;
    transition: box-shadow 0.2s, border-color 0.2s;
}
.invite-qr-wrap:hover { border-color: #409eff; box-shadow: 0 2px 12px rgba(64, 158, 255, 0.2); }
.invite-qr-img { display: block; width: 200px; height: 200px; }
.invite-qr-placeholder { display: inline-block; width: 200px; height: 200px; line-height: 200px; text-align: center; color: #909399; font-size: 14px; }
.invite-qr-tip { font-size: 12px; color: #909399; margin: 8px 0 0 0; line-height: 1.4; }
.bind-phone-section {
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #ebeef5;
}
.bind-phone-tip {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    background: #f0f9eb;
    border: 1px solid #e1f3d8;
    border-radius: 8px;
    margin-bottom: 16px;
    font-size: 14px;
    color: #67c23a;
}
.bind-phone-tip i { font-size: 18px; }
.bind-phone-form .captcha-row { display: flex; align-items: center; gap: 10px; }
.bind-phone-form .captcha-code-box {
    width: 100px; height: 36px; line-height: 36px; text-align: center; font-size: 18px; font-weight: bold;
    letter-spacing: 4px; background: #f0f2f5; border: 1px solid #dcdfe6; border-radius: 4px;
    cursor: pointer; user-select: none;
}
.bind-phone-form .captcha-code-box:hover { border-color: #409EFF; color: #409EFF; }
.bind-phone-form .captcha-input { width: 140px; }
.bind-phone-form .sms-code-btn { white-space: nowrap; }
.password-section { margin-top: 16px; }
.password-section .el-button--text { padding-left: 0; }
.password-form {
    margin-top: 12px;
    background: #f5f7fa;
    border-radius: 8px;
    padding: 16px;
}
.form-subtitle {
    font-size: 14px;
    color: #606266;
    margin: 0 0 12px 0;
}
.coin-log-card .profile-title { margin: 0; }
.coin-log-toolbar {
    padding: 12px 24px;
    border-bottom: 1px solid #ebeef5;
    display: flex;
    align-items: center;
    gap: 12px;
}
.toolbar-label { font-size: 14px; color: #606266; }
.coin-log-list {
    min-height: 200px;
    padding: 20px 24px;
}
.coin-log-empty { text-align: center; color: #909399; padding: 40px 0; font-size: 14px; }
.coin-log-items { display: flex; flex-direction: column; gap: 8px; }
.coin-log-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    background: #f5f7fa;
    border-radius: 8px;
    font-size: 14px;
}
.coin-log-item.spend .coin-log-amount { color: #f56c6c; font-weight: 600; min-width: 48px; }
.coin-log-item.earn .coin-log-amount { color: #67c23a; font-weight: 600; min-width: 48px; }
.coin-log-remark { flex: 1; color: #606266; }
.coin-log-time { color: #909399; font-size: 12px; }

@media (max-width: 768px) {
    .user-profile {
        flex-direction: column;
        padding: 0 10px 20px;
        width: 100%;
        box-sizing: border-box;
    }
    .profile-sidebar {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 0;
    }
    .sidebar-title { border-bottom: none; border-right: 1px solid #ebeef5; padding-right: 16px; margin-right: 8px; }
    .sidebar-menu {
        flex: 1;
        display: flex;
        padding: 12px 0;
        gap: 4px;
    }
    .sidebar-menu li { flex: 1; justify-content: center; padding: 10px 8px; }
    .profile-main { width: 100%; min-width: 0; }
    .profile-sections { padding: 16px; }
    .profile-card .profile-title { padding: 14px 16px; }
    .coin-log-toolbar { padding: 12px 16px; flex-wrap: wrap; }
    .coin-log-list { padding: 16px; }
    .info-label { width: 90px; }
    .invite-code-tip { margin-left: 90px; }
}

/* 分享统计样式 */
.share-stats-section {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #ebeef5;
}
.share-stats-grid {
    display: flex;
    gap: 20px;
    margin-top: 12px;
}
.share-stat-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px 12px;
    background: #f5f7fa;
    border-radius: 8px;
    border: 1px solid #ebeef5;
}
.share-stat-num {
    font-size: 28px;
    font-weight: 700;
    color: #409eff;
    line-height: 1.2;
}
.share-stat-label {
    font-size: 13px;
    color: #909399;
    margin-top: 6px;
}
@media(max-width: 768px) {
    .share-stats-grid { flex-direction: column; gap: 10px; }
    .share-stat-item { flex-direction: row; justify-content: space-between; padding: 12px 16px; }
    .share-stat-num { font-size: 22px; }
}
</style>

<!-- 暗黑模式适配 -->
<style lang="less">
.dark-mode .user-profile {
    .profile-sidebar {
        background: var(--bg-card) !important;
        box-shadow: 0 2px 12px var(--shadow-color) !important;
    }
    .sidebar-title {
        color: var(--text-primary) !important;
        border-bottom-color: var(--border-color) !important;
    }
    .sidebar-menu li {
        color: var(--text-regular) !important;
        &.active { color: #409eff !important; background: var(--hover-bg) !important; }
        &:hover { background: var(--hover-bg) !important; color: #409eff !important; }
    }
    .sidebar-menu li i { color: var(--text-secondary) !important; }
    .sidebar-menu li.active i,
    .sidebar-menu li:hover i { color: #409eff !important; }
    .profile-card {
        background: var(--bg-card) !important;
        box-shadow: 0 2px 12px var(--shadow-color) !important;
    }
    .profile-title { color: var(--text-primary) !important; border-bottom-color: var(--border-color) !important; }
    .section-title { color: var(--text-primary) !important; border-bottom-color: var(--border-color) !important; }
    .info-label { color: var(--text-secondary) !important; }
    .info-value { color: var(--text-primary) !important; }
    .invite-code-tip { color: var(--text-secondary) !important; }
    .invite-qr-wrap {
        background: var(--bg-card) !important;
        border-color: var(--border-color) !important;
    }
    .invite-qr-tip { color: var(--text-secondary) !important; }
    .invite-qr-placeholder { color: var(--text-secondary) !important; }

    /* 金币流水区域 */
    .coin-log-toolbar {
        border-bottom-color: var(--border-color) !important;
    }
    .toolbar-label { color: var(--text-regular) !important; }
    .coin-log-item {
        background: var(--bg-secondary) !important;
        border-bottom-color: var(--border-color) !important;
    }
    .coin-log-remark { color: var(--text-regular) !important; }
    .coin-log-time { color: var(--text-secondary) !important; }
    .coin-log-empty { color: var(--text-secondary) !important; }

    /* 绑定手机 */
    .bind-phone-section { border-top-color: var(--border-color) !important; }
    .bind-phone-tip { background: var(--tip-bg) !important; border-color: var(--tip-border) !important; color: var(--text-regular) !important; }
    .bind-phone-form .captcha-code-box {
        background: var(--bg-secondary) !important;
        border-color: var(--border-color) !important;
        color: var(--text-primary) !important;
        &:hover { border-color: #409eff !important; color: #409eff !important; }
    }

    /* 修改密码 */
    .password-form {
        background: var(--bg-secondary) !important;
    }
    .form-subtitle { color: var(--text-regular) !important; }

    /* 分享统计 */
    .share-stats-section { border-top-color: var(--border-color) !important; }
    .share-stat-item { background: var(--bg-secondary) !important; border-color: var(--border-color) !important; }
    .share-stat-label { color: var(--text-secondary) !important; }
}
</style>
